{
    "common": {
        "yes": "Evet",
        "no": "Hayır",
        "cancel": "İptal",
        "ok": "Tamam",
        "close": "Kapat",
        "save": "Kaydet",
        "add": "Ekle",
        "edit": "Düzenle",
        "delete": "Sil",
        "error": "Hata",
        "delete_confirm": "Silmek istediğinize emin misiniz?",
        "search": "Ara",
        "search_placeholder": "Ara...",
        "select": "Seç",
        "select_all": "Tümü Seç",
        "no_data_found": "Veri Bulunamadı",
        "success": "İşlem Başarılı",
        "confirmation": "Onaylayın"
    },
    "topBar": {
        "dark_mode": "Koyu Mod",
        "logout": "Çıkış Yap",
        "profile": "Profil",
        "light_mode": "Açık Mod"
    },
    "menuItems": {
        "admin_panel": "Yönetici Paneli",
        "import": "İçeri Aktar",
        "dashboard": "Özet",
        "users": "Kullanıcılar",
        "categories": "Kategoriler",
        "menus": "Menü",
        "levels": "Seviyeler",
        "settings": "Ayarlar",
        "profile": "Profil",
        "logout": "Çıkış"
    },
    "login": {
        "welcome": "Hoşgeldiniz",
        "subtitle": "Devam etmek için giriş yapınız",
        "email": "Email Adresi",
        "password": "Sifre",
        "login": "Giriş Yap"
    }
}
